module.exports = __webpack_public_path__ + "media/src/images/icons/tours/tour-limit-e3232c93826a1a3ec5f4a5a8dbdb5725.svg";